import {
    getData,
} from './Services'

export const getOrderHisDetailLista = async () => {
    const res = await getData('/orderhisdetail/orderhisdetail_select');
    return res
}

export const getOrderHisDetailPanel = async (searchOca,searchArt, page, perPage) => {
    let queryParams = [];
    if (searchOca) {
        queryParams.push(`ord_id=${encodeURIComponent(searchOca || '')}`);
    }
    if (searchArt) {
        queryParams.push(`art_Id=${encodeURIComponent(searchArt || '')}`);
    }
    if (page) {
        queryParams.push(`page=${encodeURIComponent(page || 1)}`);
    }
    if (perPage) {
        queryParams.push(`perPage=${encodeURIComponent(perPage || 10)}`);
    }
    const queryString = queryParams.length > 0 ? `?&${queryParams.join('&')}` : '';
     const res = await getData("/orderhisdetail/orderhisdet_filtros", queryString);
     return res
};

export const getOrderHisDetailById = async (id) => {
    const res = await getData(`/orderhisdetail/${id}`)
    return res
}
